import Constants from '../utils/consts';
import Utils from '../utils/utils';
import Cookies from 'universal-cookie';

var db = new Cookies().get('db', {path: '/' });
var http = require('follow-redirects').https;
var fs = require('fs');
var qs = require('querystring');


export default async function updateInsegnante(uname, token, id, cognome, nome, sesso, mail, mail2, indirizzo, citta, codiceFiscale, piva, telefono, telefono2_tipo, telefono2) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': Constants.apisFolder + 'updateInsegnante.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            resolve();
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
        'token': token,
        'uname': uname,
        'id': id,
        'cognome': Utils.escapeString(cognome),
        'nome': Utils.escapeString(nome),
        'sesso': sesso,
        'mail': mail,
        'mail2': mail2,
        'citta': Utils.escapeString(citta),
        'indirizzo': Utils.escapeString(indirizzo),
        'codiceFiscale': codiceFiscale,
        'partita_iva': piva,
        'telefono': telefono,
        'telefono2_tipo': telefono2_tipo,
        'telefono2': telefono2,
        'db_name': db
        });

        req.write(postData);

        req.end();

        
    });
}
